export default __webpack_public_path__ + "static/media/exist-from-patient-icon.a5339642.svg";